import React, { useEffect } from 'react';
import companyImageWelcome from '../assets/companyImageWelcome.png';
import ebook from '../assets/ebook.png';
import PublicLayout from '../templates/PublicLayout';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

const Welcome = () => {
    const location = useLocation();
    const email = location.state?.email;
    const navigate = useNavigate();

    useEffect(() => {
        const previousTitle = document.title;
        document.title = "Baixar E-book | Fonoaudiologia na Prática";

        return () => {
            document.title = previousTitle;
        };
    }, []);

    const downloadEbook = () => {
        try {
            const link = document.createElement('a');
            link.href = 'https://drive.google.com/file/d/1qveoDvzE7nPJRS-MmJ9Q3qT3BCLiob1H/view'
            
            link.download = 'E-book-Fonoaudiologia.pdf';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            alert('Erro ao baixar o eBook');
        }
    };

    if (false) {
        return <Navigate to="/ebook" replace />;
    }

    return (
        <PublicLayout>
            <div className="min-h-screen flex flex-col md:flex-row">
                {/* Imagem Responsiva */}
                <div className="w-full md:w-1/2 bg-white flex items-center justify-center">
                    <img
                        src={companyImageWelcome}
                        alt="Fonoaudiologia na Prática"
                        className="w-full h-auto object-cover md:rounded-lg"
                    />
                </div>

                {/* Conteúdo Responsivo */}
                <div className="w-full md:w-1/2 bg-white flex items-center justify-center p-6">
                    <main className="w-full max-w-md">
                        <div className="mt-7 bg-white border border-gray-200 rounded-xl shadow-sm">
                            <div className="p-4 sm:p-7">
                                <div className="text-center">
                                    <h2 className="block text-2xl font-bold text-cyan-800">
                                        Obrigada pelo seu cadastro!
                                    </h2>
                                    <p className="mt-2 text-gray-600">
                                        Baixe agora o seu eBook gratuito e siga-nos para mais novidades!
                                    </p>
                                </div>

                                <div className="w-full h-72 md:h-48 lg:h-64 mb-6 mt-6 flex justify-center">
                                    <img
                                        src={ebook}
                                        alt="E-book Fonoaudiologia"
                                        className="w-full h-full object-contain rounded-md"
                                    />
                                </div>

                                <div className="flex flex-col justify-center items-center w-full gap-4">
                                    <button
                                        onClick={downloadEbook}
                                        className="p-4 rounded-md bg-pink-600 text-white w-full md:w-auto md:min-w-[300px] text-center"
                                    >
                                        Baixar seu E-book
                                    </button>
                                    <a
                                        href="https://www.instagram.com/fonosnapratica/#"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="p-4 rounded-md bg-pink-600 text-white w-full md:w-auto md:min-w-[300px] text-center"
                                    >
                                        Seguir no Instagram
                                    </a>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        </PublicLayout>
    );
};

export default Welcome;
